import { ChangeEvent, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";

import useQuery from "../../hooks/useQuery";

// import { Item } from "../../redux/shop/shop.types";
import { cartActions } from "../../redux/cart/cart.reducer";
// import { selectCurrentCollection } from "../../redux/shop/shop.selectors";
import { selectCurrentUser } from "../../redux/user/user.selectors";

import useStyles from "./quick-view.styles";

import Price from "../price";

import { OptionButton } from "../collection-item-detail/collection-item-detail.component";
import { addItem } from "../../redux/cart/cart.utils";

const QuickView = ({
  item,
  isMouseOver,
}: {
  item: any;
  isMouseOver: boolean;
}) => {
  const dispatch = useDispatch();
  const query = useQuery();

  // const currentCollection = useSelector(selectCurrentCollection);

  const currentUser = useSelector(selectCurrentUser);

  const [selectedOptions, setSelectedOptions] = useState<any>({});

  const [selectedProductOrVariant, setSelectedProductOrVariant] =
    useState<any>(null);

  const handleSelectOption = (event: any) => {
    const { name, value } = event.target;

    setSelectedOptions({
      ...selectedOptions,
      [name]: selectedOptions[name] === value ? "" : value,
    });
  };

  const selectProductOrVariant = () => {
    let tempVariant;

    if (!item?.variantOptions || item?.variantOptions.length === 0) {
      setSelectedProductOrVariant(item);
      return;
    }

    if (
      selectedOptions &&
      Object.values(selectedOptions).some((el) => el === "")
    ) {
      setSelectedProductOrVariant("CHOOSE_OPTION");
      return;
    }

    if (
      item?.variants?.some((variant: any) =>
        _.isEqual(variant?.variantOptionsUsed.variantOptions, selectedOptions),
      )
    ) {
      tempVariant = item?.variants?.find((variant: any) =>
        _.isEqual(variant?.variantOptionsUsed.variantOptions, selectedOptions),
      );
      setSelectedProductOrVariant(tempVariant);
    } else {
      setSelectedProductOrVariant("UNAVAILABLE");
    }
  };

  useEffect(() => {
    selectProductOrVariant();
  }, [selectedOptions]);

  const [images, setImages] = useState(
    item?.imageDefault
      ? Array.isArray(item?.imageGallery) && item?.imageGallery?.length !== 0
        ? [item?.imageDefault, ...item?.imageGallery]
        : [item?.imageDefault]
      : Array.isArray(item?.imageGallery) && item?.imageGallery?.length !== 0
      ? [...item?.imageGallery]
      : [],
  );

  useEffect(() => {
    setImages(
      !!selectedProductOrVariant && typeof selectedProductOrVariant !== "string"
        ? selectedProductOrVariant.imageDefault ??
          (Array.isArray(selectedProductOrVariant?.imageGallery) &&
            selectedProductOrVariant?.imageGallery?.length !== 0)
          ? [
              selectedProductOrVariant?.imageDefault,
              ...selectedProductOrVariant?.imageGallery,
            ]
          : [selectedProductOrVariant?.imageDefault]
        : Array.isArray(selectedProductOrVariant?.imageGallery) &&
          selectedProductOrVariant?.imageGallery?.length !== 0
        ? [...selectedProductOrVariant?.imageGallery]
        : item?.imageDefault
        ? Array.isArray(item?.imageGallery) && item?.imageGallery?.length !== 0
          ? [item?.imageDefault, ...item?.imageGallery]
          : [item?.imageDefault]
        : Array.isArray(item?.imageGallery) && item?.imageGallery?.length !== 0
        ? [...item?.imageGallery]
        : [],
    );

    setCurrentImageStep(0);
  }, [item, selectedProductOrVariant]);

  const [open, setOpen] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const [currentImageStep, setCurrentImageStep] = useState(0);

  const [currentCollectionId, setCurrentCollectionId] = useState(
    query.has("collectionId") ? query.get("collectionId") : "",
  );

  const handleOpen = () => {
    setCurrentImageStep(0);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setCurrentImageStep(0);
  };

  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === "Escape") {
      handleClose();
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);

    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [open]);

  useEffect(() => {
    let initialOptions: {
      [key: string]: {};
    } = {};
    item?.variantOptions.forEach((variantOption: any) => {
      initialOptions[variantOption.label] = "";
    });

    setSelectedOptions(initialOptions);
  }, [item]);

  const classes = useStyles({
    isMouseOver,
    open,
    images,
    currentImageStep,
    isOnSale: item?.isOnSale,
    isSoldOut: item?.isSoldOut || selectedProductOrVariant?.isSoldOut,
    quantity,
    stock: selectedProductOrVariant?.quantity,
    selectedProductOrVariant,
  });

  const handleImageClick = (e: any) => {
    const imageId = parseInt(e.target.id, 10);
    setCurrentImageStep(imageId);
  };

  const handleQuantityAdd = () => {
    setQuantity(quantity + 1);
  };

  const handleQuantityRemove = () => {
    if (quantity > 0) {
      setQuantity(quantity - 1);
    }
  };

  const handleQuantityChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (+value >= 0) {
      setQuantity(+value);
    }
  };

  const addItemToCart = () => {
    addItem(
      dispatch,
      currentUser,
      { ...selectedProductOrVariant, title: item.title },
      quantity,
      currentCollectionId,
    );
  };

  const toggleCart = () => {
    dispatch({
      type: cartActions.toggleCartOpen.type,
    });
  };

  return (
    <div className={classes.container}>
      <button className={classes.openBtn} onClick={handleOpen}>
        Quick View
      </button>
      <div className={classes.quickView}>
        <div className={classes.closeBtn} onClick={handleClose}>
          X
        </div>
        <div className={classes.content}>
          <div className={classes.imagesContainer}>
            {images.length === 0 ? (
              <div className={classes.largeImage}>No Image</div>
            ) : (
              <img className={classes.largeImage} />
            )}
            <div className={classes.smallImages}>
              {images.map((image: any, index: number) => (
                <img
                  key={index}
                  className={classes.smallImage}
                  src={image.url ? image.url : image}
                  onClick={handleImageClick}
                  id={index.toString()}
                  style={{ opacity: currentImageStep === index ? 1 : 0.6 }}
                />
              ))}
            </div>
            <div className={classes.badgeContainer}>
              {item.isSoldOut && (
                <span className={`${classes.badge} ${classes.soldoutBadge}`}>
                  Soldout
                </span>
              )}
              {item.isPopular && (
                <span className={`${classes.badge} ${classes.popularBadge}`}>
                  Popular
                </span>
              )}
              {item.isOnSale && (
                <span className={`${classes.badge} ${classes.onsaleBadge}`}>
                  {item.discountRate && item.discountRate.toFixed(0)}% Sale
                </span>
              )}
            </div>
          </div>
          <div className={classes.infoAndAddToCartContainer}>
            <div className={classes.infoContainer}>
              <div>{item.brand}</div>
              <div>{item.title}</div>
              <Price
                item={
                  selectedProductOrVariant &&
                  typeof selectedProductOrVariant !== "string"
                    ? selectedProductOrVariant
                    : item
                }
              />
            </div>
            <div className={`${classes.horizontalBorder} ${classes.firstHr}`} />
            <div className={classes.optionsAndisSoldOut}>
              <div className={classes.sizeOrColorOptions}>
                {item.variantOptions && item.variantOptions.length !== 0
                  ? item.variantOptions.map((variantOption: any) => {
                      const { label, options } = variantOption;
                      return (
                        <div className={classes.optionContainer} key={label}>
                          <div>
                            <span className={classes.optionLabel}>
                              {label}:{" "}
                            </span>
                            <span className={classes.selectedOption}>
                              {selectedOptions?.[label]}
                            </span>
                          </div>
                          <div className={classes.options}>
                            {options.map((option: any) => (
                              <OptionButton
                                key={option}
                                label={label}
                                option={option}
                                handleSelectOption={handleSelectOption}
                                selectedOptions={selectedOptions}
                                inQuickview
                              />
                            ))}
                          </div>
                        </div>
                      );
                    })
                  : null}
              </div>
              <div className={classes.isSoldOut}>
                {item?.variantOptions &&
                item?.variantOptions.length !== 0 &&
                selectedProductOrVariant === "CHOOSE_OPTION"
                  ? "Choose an option"
                  : item?.variantOptions &&
                    item?.variantOptions.length !== 0 &&
                    selectedProductOrVariant === "UNAVAILABLE"
                  ? "Unavailable option"
                  : selectedProductOrVariant?.isSoldOut
                  ? "Out of stock"
                  : item?.isSoldOut
                  ? "Out of stock"
                  : `${
                      selectedProductOrVariant?.quantity &&
                      selectedProductOrVariant?.quantity < 20
                        ? `Only ${selectedProductOrVariant?.quantity} left`
                        : "In stock"
                    }`}
              </div>
            </div>
            <div
              className={`${classes.horizontalBorder} ${classes.secondHr}`}
            />
            <div className={classes.addToCartContainer}>
              <div className={classes.quantityContainer}>
                <div className={classes.quantityText}>Quantity</div>
                <div className={classes.quantityControl}>
                  <button
                    className={classes.addOrRemoveBtn}
                    onClick={handleQuantityRemove}
                    disabled={item.isSoldOut}
                  >
                    -
                  </button>
                  <input
                    type="number"
                    name="quantity"
                    value={quantity || ""}
                    placeholder={
                      item.isSoldOut ? "Out of Stock" : "Enter Quantity"
                    }
                    onChange={handleQuantityChange}
                    disabled={item.isSoldOut}
                    className={classes.quantity}
                  />
                  <button
                    className={classes.addOrRemoveBtn}
                    onClick={handleQuantityAdd}
                    disabled={item.isSoldOut}
                  >
                    +
                  </button>
                </div>
              </div>
              <button
                className={classes.addToCartBtn}
                onClick={() => {
                  if (quantity > 0) {
                    addItemToCart();
                    toggleCart();
                  }
                }}
                disabled={
                  item?.isSoldOut ||
                  quantity === 0 ||
                  !selectedProductOrVariant ||
                  selectedProductOrVariant === "CHOOSE_OPTION" ||
                  selectedProductOrVariant === "UNAVAILABLE" ||
                  selectedProductOrVariant?.isSoldOut ||
                  quantity > selectedProductOrVariant.quantity
                }
              >
                {item?.isSoldOut || selectedProductOrVariant?.isSoldOut
                  ? "Out of Stock"
                  : selectedProductOrVariant === "UNAVAILABLE"
                  ? "Unavailable"
                  : "Add to Cart"}
              </button>
            </div>
          </div>
        </div>
        <span className={classes.contentAfter} onClick={handleClose} />
      </div>
    </div>
  );
};

export default QuickView;
